import styled, { keyframes } from 'styled-components';
import { fontUi, pill } from '../../theme/typography';

export const blinking = keyframes`
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

export const StyledLiveMatch = styled.span`
  ${pill};
  margin: 8px 0 0;
  position: relative;
  z-index: 1;
  padding: 8px 20px 8px 28px;
  min-height: 32px;
  border: ${({ $chrome, theme }) =>
    $chrome === 'dark' || theme?.isDark
      ? '1px solid #ffffff'
      : '1px solid #999'};
  background: ${({ $chrome, theme }) =>
    $chrome === 'dark' || theme?.isDark ? 'transparent' : theme.surface};
  box-shadow: none;
  font-weight: 500;
  font-size: 13px;
  letter-spacing: 0.01em;
  color: ${({ $chrome, theme }) =>
    $chrome === 'dark' || theme?.isDark ? '#fff' : theme.text};
  text-decoration: none;
  width: auto;
  min-width: 180px;

  ${({ $compact }) =>
    $compact &&
    `
    margin: 0;
    padding: 0 12px 0 24px;
    min-height: 32px;
    height: 32px;
    min-width: 0;
    font-size: 12px;
    line-height: 1;
  `}

  &:hover {
    cursor: pointer;
  }
  @media only screen and (max-width: 768px) {
    width: auto;
    padding-left: 30px;
    ${({ $compact }) => $compact && 'padding-left: 24px;'}
  }
`;

export const StyledOnlineIcon = styled.span`
  width: 12px;
  height: 12px;
  border-radius: 10px;
  position: absolute;
  left: 10px;
  top: 8px;
  background-color: red;
  animation: ${blinking} 5s infinite;

  ${({ $compact }) =>
    $compact &&
    `
    width: 8px;
    height: 8px;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
  `}
`;

export const StyledWatchDiscord = styled.button`
  ${pill};
  ${fontUi};
  gap: 10px;
  margin: 8px 0 0;
  padding: 12px 16px;
  min-height: 48px;
  width: 100%;
  background: #050d0a;
  border: 1.5px solid rgba(255, 255, 255, 0.92);
  border-radius: ${({ theme }) => theme.cardRadius};
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
`;

export const StyledLiveBadge = styled.span`
  ${pill};
  gap: 5px;
  padding: 4px 8px;
  background: #e53935;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  border-radius: 999px;
`;

export const StyledLiveDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fff;
`;
